/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreatePersonCommandCreatePersonDTO } from '../models/CreatePersonCommandCreatePersonDTO';
import type { CreatePersonCommandResponse } from '../models/CreatePersonCommandResponse';
import type { DeletePersonCommandResponse } from '../models/DeletePersonCommandResponse';
import type { EditPersonCommandRequest } from '../models/EditPersonCommandRequest';
import type { EditPersonCommandResponse } from '../models/EditPersonCommandResponse';
import type { GetPersonCommandResponse } from '../models/GetPersonCommandResponse';
import type { ListPersonsCommandRequest } from '../models/ListPersonsCommandRequest';
import type { ListPersonsCommandResponse } from '../models/ListPersonsCommandResponse';
import type { SendEmailWithTokenCommandResponse } from '../models/SendEmailWithTokenCommandResponse';
import type { SendEmailWithTokenCommandSendEmailWithTokenDTO } from '../models/SendEmailWithTokenCommandSendEmailWithTokenDTO';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PersonsApiService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param query
     * @returns ListPersonsCommandResponse OK
     * @throws ApiError
     */
    public getApiV10PersonsList(
        query?: ListPersonsCommandRequest,
    ): Observable<ListPersonsCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/Persons/list',
            query: {
                'query': query,
            },
        });
    }
    /**
     * @param guid
     * @returns GetPersonCommandResponse OK
     * @throws ApiError
     */
    public getApiV10Persons(
        guid: string,
    ): Observable<GetPersonCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/Persons/{guid}',
            path: {
                'guid': guid,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param guid
     * @param requestBody
     * @returns EditPersonCommandResponse OK
     * @throws ApiError
     */
    public putApiV10Persons(
        guid: string,
        requestBody?: EditPersonCommandRequest,
    ): Observable<EditPersonCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v1.0/Persons/{guid}',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param guid
     * @returns DeletePersonCommandResponse OK
     * @throws ApiError
     */
    public deleteApiV10Persons(
        guid: string,
    ): Observable<DeletePersonCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v1.0/Persons/{guid}',
            path: {
                'guid': guid,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CreatePersonCommandResponse OK
     * @throws ApiError
     */
    public postApiV10Persons(
        requestBody?: CreatePersonCommandCreatePersonDTO,
    ): Observable<CreatePersonCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Persons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SendEmailWithTokenCommandResponse OK
     * @throws ApiError
     */
    public postApiV10PersonsSendEmailWithToken(
        requestBody?: SendEmailWithTokenCommandSendEmailWithTokenDTO,
    ): Observable<SendEmailWithTokenCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Persons/send-email-with-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
